/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Info (`teal-300`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_INFO_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <path
      clipRule="evenodd"
      d="M88 34.0002C60.4 34.0002 38 56.4002 38 84.0002C38 111.6 60.4 134 88 134C115.6 134 138 111.6 138 84.0002C138 56.4002 115.6 34.0002 88 34.0002ZM88.0002 109C85.2502 109 83.0002 106.75 83.0002 104V84.0005C83.0002 81.2505 85.2502 79.0005 88.0002 79.0005C90.7502 79.0005 93.0002 81.2505 93.0002 84.0005V104C93.0002 106.75 90.7502 109 88.0002 109ZM83.0002 69.0001H93.0002V59.0001H83.0002V69.0001Z"
      fill="#057E91"
      fillRule="evenodd"
    />
    <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.833C118.636 107.833 107.833 118.636 107.833 132C107.833 145.364 118.636 156.167 132 156.167C145.364 156.167 156.167 145.364 156.167 132C156.167 118.636 145.364 107.833 132 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
